import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';
import { ColumnAlias } from '../../+state/column-aliases/interfaces/column-alias.interface';
import { ColumnsAliasesService } from '../columns-aliases.service';

@Injectable()
export class ColumnsAliasesResolver implements Resolve<ColumnAlias[]> {
  constructor(private _columnsService: ColumnsAliasesService) {}

  public resolve(): Observable<ColumnAlias[]> {
    return this._columnsService.getColumnsAliases();
  }
}
